import get from 'lodash-es/get'
import join from 'lodash-es/join'
import set from 'lodash-es/set'
import assign from 'lodash-es/assign'
import isNil from 'lodash-es/isNil'
import isEmpty from 'lodash-es/isEmpty'
import includes from 'lodash-es/includes'
import filter from 'lodash-es/filter'
import debounce from 'lodash-es/debounce'
import isPlainObject from 'lodash-es/isPlainObject'
import inRange from 'lodash-es/inRange'
import trim from 'lodash-es/trim'
import capitalize from 'lodash-es/capitalize'
import isEqual from 'lodash-es/isEqual'
import uniq from 'lodash-es/uniq'
import remove from 'lodash-es/remove'
import maxBy from 'lodash-es/maxBy'
import round from 'lodash-es/round'
import ceil from 'lodash-es/ceil'
import cloneDeep from 'lodash-es/cloneDeep'
import multiply from 'lodash-es/multiply'
import delay from 'lodash-es/delay'
import sortBy from 'lodash-es/sortBy'
import map from 'lodash-es/map'
import pick from 'lodash-es/pick' // use pick lodash
import max from 'lodash-es/max'
import min from 'lodash-es/min'
import sumBy from 'lodash-es/sumBy'

export default {
  get,
  set,
  assign,
  isNil,
  isEmpty,
  includes,
  filter,
  debounce,
  isPlainObject,
  inRange,
  trim,
  capitalize,
  isEqual,
  uniq,
  join,
  remove,
  maxBy,
  round,
  ceil,
  cloneDeep,
  multiply,
  delay,
  sortBy,
  map,
  pick,
  max,
  min,
  sumBy
}
